var modules_be025dea = {"container":"Select_module_container__1300b05b","menu":"Select_module_menu__1300b05b","icon":"Select_module_icon__1300b05b","is-arrow-turned":"Select_module_isArrowTurned__1300b05b"};
import "../../../assets/esm/components/Select/src/Select~D5TMOwbY.css";

export { modules_be025dea as default };
//# sourceMappingURL=Select.module.less.js.map
